import { PaymentApiClient } from '@fourthwall/services/dist/PaymentApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useShopPaymentMethodsQuery = createQueryHook(PaymentApiClient.getShopPaymentMethods, {
  queryKey: ['shopPaymentMethods'],
})
